function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_dddd)"
}, React.createElement("path", {
  d: "M74 17.812V32.7477C73.8808 33.1294 73.7955 33.5273 73.6358 33.8895C72.7313 35.9366 71.165 36.9366 69.0497 36.9816C67.4244 37.0162 65.7969 36.9896 64.1716 36.9896H37.1155C35.3338 36.9896 33.8692 36.3115 32.8148 34.7579C32.4025 34.1513 32.1816 33.4581 32 32.7477V17.812C32.1859 17.7798 32.3467 17.872 32.513 17.9274C38.8742 20.1571 45.2344 22.3869 51.5934 24.6167C52.4892 24.9476 53.4642 24.9524 54.3628 24.6305C60.6708 22.4154 66.9807 20.2048 73.2923 17.9989C73.5231 17.9216 73.7441 17.7936 74 17.812Z",
  fill: "#2F66E3"
}), React.createElement("path", {
  d: "M74 9.78475V14.9644C73.8305 15.0186 73.6587 15.0682 73.4914 15.127C66.9391 17.4244 60.3868 19.7238 53.8345 22.025C53.3281 22.2038 52.8502 22.2719 52.3241 22.0827C47.9381 20.5273 43.5482 18.9845 39.1542 17.4544C36.7713 16.6202 34.3866 15.7901 32 14.9644V9.78475C32.0405 9.6475 32.0831 9.51026 32.1192 9.37186C32.2831 8.70008 32.5768 8.07126 32.9821 7.52487C33.3873 6.97848 33.8952 6.52631 34.4741 6.19674C35.267 5.72733 36.1322 5.54395 37.0345 5.5428H45.3591C45.9114 5.5428 45.93 5.51858 45.9333 4.92692C45.9333 4.56708 45.9333 4.20724 45.9333 3.84856C45.9978 1.64108 47.4547 0.0667847 49.5514 0.0298781C51.8483 -0.0104884 54.1452 -0.00472178 56.442 0.0298781C58.2052 0.0552514 59.5745 1.22934 59.9541 2.95126C60.0908 3.57291 60.0634 4.2084 60.0634 4.84157C60.0634 5.54165 60.0634 5.5428 60.7197 5.5428C63.4945 5.5428 66.2705 5.51743 69.0442 5.55203C71.1617 5.57971 72.728 6.59002 73.638 8.64295C73.7966 9.00048 73.8808 9.403 74 9.78475ZM52.9573 5.54049C53.7634 5.54049 54.5695 5.54049 55.3756 5.54049C56.5623 5.53127 56.4278 5.69619 56.4322 4.39985C56.4322 3.87393 56.3983 3.84048 55.8853 3.83933C54.1506 3.83933 52.4159 3.83126 50.6812 3.83933C49.4169 3.84625 49.5788 3.64672 49.558 5.04341C49.5514 5.41939 49.6958 5.54972 50.0447 5.54395C51.0181 5.53242 51.9883 5.54049 52.9573 5.54049Z",
  fill: "#2F66E3"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_dddd",
  x: 0,
  y: 0,
  width: 106,
  height: 101,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.662745 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  mode: "multiply",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dy: 8
}), React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.662745 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  mode: "multiply",
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dy: 16
}), React.createElement("feGaussianBlur", {
  stdDeviation: 8
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.662745 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  mode: "multiply",
  in2: "effect2_dropShadow",
  result: "effect3_dropShadow"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dy: 32
}), React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.662745 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  mode: "multiply",
  in2: "effect3_dropShadow",
  result: "effect4_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect4_dropShadow",
  result: "shape"
})));

var SvgBaLago = function SvgBaLago(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 180,
    height: 60,
    viewBox: "0 0 106 101",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBaLago, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ba_lago.a2a57923.svg";
export { ForwardRef as ReactComponent };